import { configureStore } from '@reduxjs/toolkit';
import superAdminReducer from '../modules/superAdmin/superAdminSlice';
import tenantReducer from '../modules/tenant/tenantSlice';
import authReducer from '../slice/authSlice';
import adminReducer from '../slice/adminSlice';

export const store = configureStore({
    reducer: {
        superAdmin: superAdminReducer,
        tenant: tenantReducer,
        auth: authReducer,
        admin: adminReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
